import { render, staticRenderFns } from "./HeaderActions.vue?vue&type=template&id=56c0c4c2&scoped=true"
import script from "./HeaderActions.vue?vue&type=script&lang=js"
export * from "./HeaderActions.vue?vue&type=script&lang=js"
import style0 from "./HeaderActions.vue?vue&type=style&index=0&id=56c0c4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c0c4c2",
  null
  
)

export default component.exports